// frontend/src/askos/RecentConversationsCard.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api, { askosAuthHeader } from './askosApi';

const PILL_COLORS = { Polity: 'blue', Environment: 'green', Economy: 'amber' };
const pillColor = (subject) => PILL_COLORS[subject] || 'blue';

const formatTimestamp = (iso) => {
    if (!iso) return '';
    const date = new Date(iso);
    const now = new Date();
    const time = date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
    const isSameDay = date.toDateString() === now.toDateString();
    const yesterday = new Date(now); yesterday.setDate(now.getDate() - 1);
    const isYesterday = date.toDateString() === yesterday.toDateString();
    if (isSameDay) return `Today, ${time}`;
    if (isYesterday) return `Yesterday, ${time}`;
    return date.toLocaleDateString([], { day: 'numeric', month: 'short', year: 'numeric' });
};

const RecentConversationsCard = ({ slug, limit = 4 }) => {
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        api.get(`/tenant/${slug}/askos/sessions`, { headers: askosAuthHeader() })
            .then(res => setSessions((res.data || []).slice(0, limit)))
            .catch(() => setSessions([]))
            .finally(() => setLoading(false));
    }, [slug, limit]);

    return (
        <article className="panel">
            <div className="panel-heading">
                <h3>Recent Conversations</h3>
                <a href="#" onClick={e => { e.preventDefault(); navigate('/samkalp-ias/ask-askos'); }}>View All</a>
            </div>
            {loading && <p className="empty-note">Loading…</p>}
            {!loading && sessions.length === 0 && <p className="empty-note">No conversations yet — ask AskOS a doubt to get started.</p>}
            {sessions.map(s => (
                <div
                    key={s.session_id}
                    className="conversation-row"
                    onClick={() => navigate(`/samkalp-ias/ask-askos?session=${s.session_id}`)}
                >
                    <div className="conversation-icon">◌</div>
                    <div>
                        <strong>{s.subject || 'General'} conversation</strong>
                        <span>{formatTimestamp(s.updated_at)}</span>
                    </div>
                    <span className={`pill ${pillColor(s.subject)}`}>{s.subject || 'General'}</span>
                </div>
            ))}
        </article>
    );
};

export default RecentConversationsCard;
